import { render, staticRenderFns } from "./oneside.vue?vue&type=template&id=1e626bb5"
import script from "./oneside.vue?vue&type=script&lang=js"
export * from "./oneside.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports